import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagEventVO } from 'tag/ts/tag/events/TagEventVO';
import { TagLoggerString } from 'tag/ts/tag/model/enums/TagLoggerString';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { PlayerType } from 'tag/ts/tag/model/type/PlayerType';
import { TagDomAttribute } from 'tag/ts/tag/model/type/TagDomAttribute';
export class EmbedManager extends AbstractTagClass {
    #playerContainer;
    #onReadyResolve;
    #onFailureReject;
    constructor(argument) {
        super({ tag: argument?.tag, name: 'EmbedManager' });
        this.#onReadyResolve = argument?.onReadyResolve;
        this.#onFailureReject = argument?.onReadyReject;
        const eventsOfInterest = [
            TagEvent.ON_METADATA_READY,
            TagEvent.ON_SESSION_START_IMPORTS_DONE
        ];
        if (this?.params?.SKIN?.enabled === true
            &&
                this?.tag?.view?.playerType === PlayerType.CHROMELESS
            &&
                this.params.SYSTEM.embedType !== EmbedType.HTML5) {
            eventsOfInterest.push(TagEvent.ON_CUSTOM_SKIN_READY);
        }
        this.tagEventsHandler(this.#onTagEvent, eventsOfInterest);
    }
    get playerContainer() {
        if (this?.params?.SKIN?.enabled === false) {
            this.#playerContainer = this.tag?.view?.smartTagContentElement;
            return this.#playerContainer;
        }
        switch (this?.tag?.view?.playerType) {
            case PlayerType.CHROMELESS:
                return this.#playerContainer;
            case PlayerType.FULL:
                this.#playerContainer = this.tag?.view?.smartTagContentElement;
                break;
        }
        return this.#playerContainer;
    }
    #instantiateSkin = () => {
        const skinImport = this.tag.model.config.tag.Imports.params.smart_tag.skin;
        const SkinClass = this.utils.DOM.getDeepVal(window, skinImport?.namespace);
        switch (SkinClass !== null) {
            case true:
                this.logger.groupCollapsed('instantiateSkin:', 'Create new instance of Skin class.');
                this.tag.view.skin = new SkinClass({
                    tag: this.tag,
                    containerSelector: `[${TagDomAttribute.CONTENT}="${this.uuid}"]`
                });
                break;
            case false:
                this?.logger?.warn('instantiateSkin:', 'Skin class does not exist:', SkinClass);
                break;
        }
    };
    #executeOnReadyEvent = () => {
        this.utils.Delay.delay()
            .then(() => {
            this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_READY, this.tag, this.getTagEventDataVO(), this, this?.name));
            if (this.utils.Type.isFunction(this.#onReadyResolve)) {
                this.#onReadyResolve({ msg: 'TagEvent.ON_READY', tag: this.tag });
            }
        });
    };
    #onImportsDone = () => {
        this?.logger?.log('onImportsDone:', this?.tag?.view?.playerType);
        if (this?.params?.SKIN?.enabled === false) {
            this.#executeOnReadyEvent();
            return;
        }
        switch (this?.tag?.view?.playerType) {
            case PlayerType.CHROMELESS:
                this?.logger?.log('EmbedManager.ts > this.runtimeVO?.readyCallback?.detectAutoplay', this.runtimeVO?.readyCallback?.detectAutoplay);
                const shouldDetectAutoplay = this.utils.Type.isEmpty(window.SmartTag.autoplay)
                    &&
                        this.runtimeVO?.readyCallback?.detectAutoplay === true;
                switch (shouldDetectAutoplay) {
                    case false:
                        this.#instantiateSkin();
                        break;
                    case true:
                        this.tag.controller.playerManager.playerAdapter.getAutoplayCapabilities()
                            .then((autoplayInfo) => {
                            this.#instantiateSkin();
                        });
                        break;
                }
                break;
            case PlayerType.FULL:
                this.#executeOnReadyEvent();
                break;
        }
    };
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_SESSION_START_IMPORTS_DONE:
                this?.logger?.log(TagLoggerString.ON_TAG_EVENT, event?.type, event);
                this.#onImportsDone();
                break;
            case TagEvent.ON_CUSTOM_SKIN_READY:
                this.logger.groupEnd();
                this?.logger?.log(TagLoggerString.ON_TAG_EVENT, event?.type, event);
                this.#playerContainer = event?.data?.playerContainer;
                this.#executeOnReadyEvent();
                break;
            case TagEvent.ON_METADATA_READY:
                this?.logger?.log(TagLoggerString.ON_TAG_EVENT, event?.type, event, this.params);
                this.dispatchTagEvent(new TagEventVO(TagEvent.ON_CREATE_PLAYER_REQUEST, this.tag, { playerContainer: this.playerContainer }, this));
                break;
        }
    };
}
